import { useDispatch } from 'react-redux';

import { setSegmentDate } from '@entities/exchange';

export function useSelectSegmentDate() {
	const dispatch = useDispatch();

	const onSetSegmentDate = (id: string, date: Date) => {
		dispatch(setSegmentDate({ id, date }));
	};

	return { onSetSegmentDate };
}
